import OwlCarousel from 'react-owl-carousel';  
import { Link } from 'react-router-dom';

export default function BrandFive(){
    return(
        <div class="brand-area home-5">
			<div class="container">
            <OwlCarousel items={5}  
            className="owl-theme brand-border brand-slide2"  
            loop 
            center={true}
            autoplay={true}
            dots={false}			  
            margin={30} >
                <div class="brand-item">
                    <Link class="brand-img" href="#">
                        <img class="front" src="assets/img/home-5/h4-partnar-logo-5.webp" alt="Brand" />
                        <img class="back" src="assets/img/home-5/h4-partnar-logo-5.webp" alt="Brand" />
                    </Link>
                </div>
                <div class="brand-item">
                    <Link class="brand-img" href="#">
                        <img class="front" src="assets/img/home-5/h4-partnar-logo-4.webp" alt="Brand" />
                        <img class="back" src="assets/img/home-5/h4-partnar-logo-4.webp" alt="Brand" />
                    </Link>
                </div>
                <div class="brand-item">
						<Link class="brand-img" href="#">
							<img class="front" src="assets/img/home-5/h4-partnar-logo-3.webp" alt="Brand" />
							<img class="back" src="assets/img/home-5/h4-partnar-logo-3.webp" alt="Brand" />
						</Link>
					</div>
                    <div class="brand-item">
						<Link class="brand-img" href="#">
							<img class="front" src="assets/img/home-5/h4-partnar-logo-2.webp" alt="Brand" />
							<img class="back" src="assets/img/home-5/h4-partnar-logo-2.webp" alt="Brand" />
						</Link>
					</div>
                    <div class="brand-item">
						<Link class="brand-img" href="#">
							<img class="front" src="assets/img/home-5/h4-partnar-logo-1.webp" alt="Brand" />
							<img class="back" src="assets/img/home-5/h4-partnar-logo-1.webp" alt="Brand" />
						</Link>
					</div>
                    <div class="brand-item">
						<Link class="brand-img" to="#">
							<img class="front" src="assets/img/home-5/h4-partnar-logo-6.webp" alt="Brand" />
							<img class="back" src="assets/img/home-5/h4-partnar-logo-6.webp" alt="Brand" />
						</Link>
					</div>
            </OwlCarousel>				
			</div>
		</div>
    )
}